import { z } from 'zod';

/** Предусловие отправителя: не заменяет сессию и не даёт никаких прав. */
export const RequestIdentity = z.strictObject({
  userId: z.uuid(),
  tenantId: z.uuid(),
});
export type RequestIdentity = z.infer<typeof RequestIdentity>;

export const EXPECTED_USER_HEADER = 'x-epc-expected-user-id';
export const EXPECTED_TENANT_HEADER = 'x-epc-expected-tenant-id';
